<template>
    <section>
        <ui-breadcrumb title="Compose Message" :items="['Projects', 'SMS', 'Compose']"></ui-breadcrumb>
        <div class="content">
            <form class="mb-5" action="" method="POST" @submit.prevent="sendMessage">
                <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label>Send At</label>
                                <div class="form-group">
                                    <el-date-picker
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        ref="sent-at-time-picker"
                                        size="large"
                                        proper-class="form-control"
                                        v-model="payload.sendAt"
                                        type="datetime"
                                        placeholder="Select date and time"
                                        default-time="12:00:00">
                                    </el-date-picker>
                                    <div v-if="formErrors.sendAt" :class="['text-danger']">
                                        <small>{{formErrors.sendAt[0]}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="form-group">
                                <label for="sender-id">From</label>
                                <v-select :class="{'is-invalid': formErrors.from}"
                                          v-model="payload.from"
                                          id="sender-id"
                                          label="senderName"
                                          :reduce="option => option.senderName"
                                          :options="shortCodes">
                                </v-select>
                                <div v-if="formErrors.from" :class="['invalid-feedback']">
                                    {{formErrors.from[0]}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <label for="recipient">Phone Number Field</label>
                            <v-select :reduce="option => option"
                                      :class="{'is-invalid': formErrors.phoneNumberField}"
                                      :options="metadata.headers"
                                      id="recipient"
                                      v-model="payload.phoneNumberField">
                            </v-select>
                            <div v-if="formErrors.phoneNumberField" :class="['text-danger help-block']">
                                {{formErrors.phoneNumberField[0]}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <strong class="h5">Available Variables</strong>
                            <div class="">
                                <el-tag
                                    v-for="(variable, index) in metadata.headers"
                                    :key="index"
                                    type="info"
                                    class="pr-1"
                                    effect="plain"
                                >
                                    {%{{variable}}%}
                                </el-tag>
                            </div>
                            <div class="form-group">
                                <label for="compose-message">Text Message</label>
                                <textarea :class="{'is-invalid': formErrors.message}" @blur="countCharacters"
                                          @keyup="countCharacters" id="compose-message"
                                          class="form-control" v-model="payload.message" rows="4"
                                          placeholder="Compose your message"/>
                                <span class='float-right text-right pt-1 pb-3 text-muted'
                                      :class="{'font-w700': messageCount > 1}">
                                    <small class="font-italic">{{messageCount}} Message(s) | {{remainingCount}}
                                        Characters Remaining
                                    </small>
                                </span>
                                <div v-if="formErrors.message" :class="['invalid-feedback']">
                                    {{formErrors.message[0]}}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group float-right">
                                <button :disabled="loading" type="submit" :class="['btn', 'btn-hero', 'btn-outline-success']">
                                    <span class="si si-control-play mr-2"/>
                                    Send Message
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import ShortCodeApi from '../../api/shortcodes';
    import VueSelect from 'vue-select';
    import Tribute from "tributejs";

    export default {
        name: "ComposeCustomBulkMessage",
        components: {
            'v-select': VueSelect
        },
        data() {
            return {
                shortCodes: [],
                formErrors: [],
                hasError: false,
                loading: false,
                phoneNumberField: '',
                messageCount: 1,
                remainingCount: 160,
                metadata: {},
                payload: {
                    filePath: '',
                    from: '',
                    phoneNumberField: '',
                    messageType: 'Bulk',
                    message: '',
                    sentAt: '',
                    identifier: '',
                }
            }
        },
        beforeMount() {
            this.loadShortCodes();
            let req = this.$route.query.req, project = this.$route.params.project;

            axios.get(`web/projects/${project}/sms/custom/compose?req=${req}`).then(res => {
                this.metadata = res.data.data;
                this.payload.filePath = this.metadata.filePath;
                this.payload.identifier = req;
                let values = _.map(this.metadata.headers, function (val) {
                    return {
                        key: val,
                        value: val
                    }
                });
                let tribute = new Tribute({
                    values: values,
                    trigger: '@',
                    selectTemplate: function (item) {
                        return '{%' + item.original.value + '%}';
                    },
                });
                tribute.attach(document.getElementById("compose-message"))
            }).catch(() => {
                this.$router.replace(`/projects/${project}/sms/custom/upload-file`)
            })
        },
        methods: {

            sendMessage() {
                let project = this.$route.params.project;
                this.loading = true
                axios.post(`web/projects/${project}/sms/custom/send`, this.payload).then(res => {
                    this.$notify({
                        message: 'Message has been queued for dispatch',
                        title: 'Operation successful',
                        type: 'success'
                    });
                    this.$router.push(`/projects/${project}/sms/bulk-outbox`);
                }).catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.formErrors = error.response.data.errors;
                        this.hasError = true;
                    }
                }).finally(() => this.loading = false)
            },

            loadShortCodes() {
                ShortCodeApi.getAllProjectShortCodes({
                    project: this.$route.params.project,
                    service: 'bulk'
                }).then(result => this.shortCodes = result);
            },

            countCharacters() {
                let count = Math.ceil(((this.message.message.length) / 160));
                this.messageCount = count === 0 ? 1 : count;
                this.remainingCount = 160 * this.messageCount - this.message.message.length;
            },
            removeRecipient(index) {
                this.message.recipients.splice(index, 1);
            }
        }
    }
</script>

<style scoped>
    .highlight {
        color: #2bbf69;
        font-weight: bold;
    }
</style>
